/**
 * TODO:
 * - Invalidate on refresh / handle resizing
 * - Add loader?
 */

// TODO: Move the application of the 4 vars below to reference this object
// TODO: Add setter / getter (maybe convert to class instance!)
window.blockTriggers = {
  active: null,
  scrolling: false,
  triggers: {},
  labelPositions: [],
};
window.initialized = false;
// TODO: Replace triggers var usage with this and rename
window.roadmapBlocks = {};
window.triggers = {};
window.labelKeys = [];
window.labelPositions = [];
window.isScrolling = false;
window.isRefreshed = false;
const blocks = Array.from(document.querySelectorAll('[data-block]'));
const header = document.querySelector('.doen-header');
const mql = window.matchMedia('(min-width: 750px)');
// let mm = gsap.matchMedia();

const setViewportHeight = () => {
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
}
setViewportHeight();
window.addEventListener('resize', setViewportHeight);

// Switching breakpoints was breaking everything. This is a crude fix.
mql.addEventListener('change', e => {
  window.location.reload();
});

const SCROLL_OFFSET = 1;
const OVERFLOW_BUFFER = 30;

const refresh = () => {
  if (!window.initialized) return;
  getLabels();
  roadmapController?.resetHeaderObserver();

  if (window.isRefreshed) {
    roadmapController.getActiveBlock()?.scrollTo({ animate: false });
  } else {
    window.isRefreshed = true;
  }
}

const scrollTriggerDefaults = {};

let scrollContainer = window;
if (!mql.matches) {
  scrollContainer = document.getElementById('viewport');
  scrollTriggerDefaults.scroller = '#viewport';
} else {
  scrollTriggerDefaults.invalidateOnRefresh = true;
}

ScrollTrigger.defaults(scrollTriggerDefaults);

ScrollTrigger.addEventListener('refreshInit', () => {
  Object.values(triggers).forEach(triggerBlock => {
    triggerBlock.trigger.updateBuffer();
  });
});

ScrollTrigger.addEventListener('refresh', refresh);

// TODO: Clean up
function addWeightedEases() {
    let eases = gsap.parseEase(),
        createConfig = ease => ratio => {
          let y = 0.5 + ratio / 2;
          return p => ease(2 * (1 - p) * p * y + p * p);
        };
    for (let p in eases) {
      if (!eases[p].config) {
          eases[p].config = createConfig(eases[p]);
      }
    }
}

class RoadmapController {
  constructor() {
    this.activeBlock = null;
    this.updateScroll = this.updateScroll.bind(this);
    this.updateFreeze = this.updateFreeze.bind(this);
    this.observerOptions = {
      target: scrollContainer,
      type: 'wheel,touch',
    };

    this.scrollOptions = {
      ...this.observerOptions,
      debounce: false,
      dragMinimum: 5,
      tolerance: 200,
      axis: 'y',
      onChangeY: this.updateScroll,
    };

    this.freezeOptions = {
      ...this.observerOptions,
      preventDefault: true,
      onChangeY: this.updateFreeze,
      onStopDelay: 0.1,
      onStop: () => {
        if (this.scrollObserver.isLocked) {
          this.scrollObserver.isLocked = false;
        }
      },
    };

    this.initHeaderObserver();

    this.scrollObserver = ScrollTrigger.observe(this.scrollOptions);
    this.freezeObserver = ScrollTrigger.observe(this.freezeOptions);
  }

  getBlock(block) {
    if (typeof block !== 'string') return block;

    return roadmapBlocks[block];
  }

  setActiveBlock(block) {
    block = this.getBlock(block);

    if (!block) return;

    this.activeBlock = block;
  }

  // TODO: Map active block to controller instead of window
  getActiveBlock() {
    return this.activeBlock;
  }

  initHeaderObserver() {
    this.headerObserver = new IntersectionObserver((entries, observer) => {      
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const { target } = entry;
          const block = (target.classList.contains('pin-spacer') ? target.firstElementChild : target).block;
          if (block.ignoreHeader) return;

          block?.updateHeader();
        }
      }
    }, {
      rootMargin: `-1px 0px ${header.offsetHeight - window.innerHeight}px 0px`,
      threshold: 0,
    });
  }

  observeHeader() {
    for (const block of blocks) {
      // TODO: Clean up
      const target = (block.parentElement.classList.contains('pin-spacer')) ? block.parentElement : block;

      this.headerObserver.observe(target);
    }
  }

  resetHeaderObserver() {
    this.headerObserver.disconnect();
    this.initHeaderObserver();
    this.observeHeader();
  }

  // TODO: Clean up to use roadmap blocks
  handleScroll(direction = 1) {
    if (direction === 0) return;

    const scrollPosition = (scrollContainer.scrollY ?? scrollContainer.scrollTop),
          block = this.getActiveBlock(),
          // TODO: Remove once `getAdjacentTrigger` is updated
          trigger = block.trigger,
          destinationBlock = getAdjacentTrigger(trigger, direction),
          labelPosition = getAdjacentLabelPosition(direction),
          // TODO: Replace with `block.triggerOffset` once `getAdjacentTrigger` is updated
          offset = (destinationBlock.vars.id === '00-1' || scrollPosition === 0) ? 0 : SCROLL_OFFSET,
          destination = labelPosition + offset;

    if (destination === scrollPosition) return;

    const scrollerEndProgress = (direction > 0) ? 1 : 0;
    if (!block.hasOverflow() || block.scroller.progress === scrollerEndProgress) {
      scrollTo(destination);
      return;
    }

    const y = block.getScrollerEnd(direction);
    const ease = 'none';
    const distance = Math.abs(y - block.triggerEl.scrollTop);

    const innerDuration = getScrollDuration({ distance, min: 0 });
    const outerDuration = getScrollDuration({ end: destination });
    const duration = innerDuration + outerDuration;

    const animator = gsap.timeline({ ease, paused: true });
    animateScroll(block.triggerEl, { y, duration: innerDuration, ease, animator });
    animateScroll(scrollContainer, { y: destination, duration: outerDuration, ease, animator });

    gsap.to(animator, {
      progress: 1,
      duration,
      ease: 'power1.inOut',
      onComplete: () => {
        animator.kill();
      }
    });
  }

  updateScroll(observer) {
    if (observer.isLocked || window.isScrolling || window.isFrozen || window.internalScroll) return;
    const direction = Math.sign(observer.deltaY) * (observer.isDragging ? -1 : 1);

    this.handleScroll(direction);
  }

  // TODO: Improve so internal scrolling works after hitting edge and reversing direction
  updateFreeze(observer) {
    if (window.isScrolling || window.isFrozen) return;

    const direction = Math.sign(observer.deltaY) * (observer.isDragging ? -1 : 1);
    const startProgress = (direction > 0) ? 0 : 1;
    const endProgress = (direction > 0) ? 1 : 0;

    if (
      (window.internalScroll && ![0, 1].includes(window.internalScroll.progress)) ||
      (!window.internalScroll && direction === (Math.sign(observer.lockDelta) * -1) && window.previousInternalScroll?.progress === startProgress) // Reversed direction at start / end
    ) {
      window.internalScroll ||= window.previousInternalScroll;
      this.scrollObserver.isLocked = false;
      observer.lockDelta = 0;
      observer.disable();
      return;
    }

    if (
      this.scrollObserver.isLocked &&
      Math.sign(observer.deltaY) === Math.sign(observer.lockDelta) &&
      Math.abs(observer.deltaY) > Math.abs(observer.lockDelta)
    ) {
      this.scrollObserver.isLocked = false;
      observer.lockDelta = 0;
    }

    if (window.internalScroll?.progress === startProgress) {
      observer.disable();
    } else if (window.internalScroll?.progress === endProgress && !this.scrollObserver.isLocked) {
      this.scrollObserver.isLocked = true;
      observer.lockDelta = observer.deltaY;
      window.previousInternalScroll = window.internalScroll;
      window.internalScroll = false;
    }
  }
}

const roadmapController = new RoadmapController();

const configureFromViewport = (e = mql) => {
  if (e.matches) {
    roadmapController.scrollObserver.enable();
    refresh();
  } else {
    roadmapController.freezeObserver.disable();
    roadmapController.scrollObserver.disable();
  }
};

// mql.addEventListener('change', configureFromViewport);
configureFromViewport();

// TODO: Consider reworking as web component
class RoadmapBlock {
  // TODO: Clean up constructor signature
  constructor(trigger, {
    tweens = [],
    start = `top top+=${SCROLL_OFFSET}px`,
    end = `bottom top+=${SCROLL_OFFSET}px`,
    pin = true, // TODO: Consider making false default
    pinBuffer = true,
    clone = false,
    cloneFooter = false,
    markers = false,
    scrub = true,
    onEnter = null,
    onEnterBack = null,
    onLeave = null,
    onLeaveBack = null,
    onRefresh = null,
    ignoreHeader = false,
  } = {}) {
    this.triggerEl = trigger;
    this.heightEl = trigger.querySelector('.roadmap-block__wrapper');
    this.id = getBlockId(trigger);
    this.triggerOffset = this.id === '00-1' ? 0 : SCROLL_OFFSET;
    this.tweens = tweens;
    this.pinBuffer = pinBuffer;
    this.handleEnter = this.enter.bind(this);
    this.handleBuffer = this.updateBuffer.bind(this);
    this.handleRefresh = this.update.bind(this);
    this.ignoreHeader = ignoreHeader;

    // TODO: Move callback args under `callbacks` key, loop through and add to each
    this.callbacks = {
      onEnter: [ this.handleEnter, onEnter ],
      onEnterBack: [ this.handleEnter, onEnterBack ],
      onLeave: [ onLeave ],
      onLeaveBack: [ onLeaveBack ],
      onRefresh: [ this.handleRefresh, onRefresh ],
    };

    this.options = {
      id: this.id,
      trigger,
      markers,
      start,
      end,
      scrub,
      pin,
      pinSpacing: false,
      toggleActions: 'play none none reverse',
    };

    if (this.id === '00-1' && !mql.matches) {
      this.options.pinType = 'fixed';
      this.triggerEl.style.pointerEvents = 'none';
      this.triggerEl.querySelector('.arrow').style.pointerEvents = 'initial';
    }

    this.addCallbacks();

    // TODO: Convert to constants
    this.headerColor = this.triggerEl.querySelector('.roadmap-block__image') ? 'rgb(255, 255, 255)' : 'rgb(51, 50, 48)';

    this.updateBuffer();

    this.triggerEl.updateBuffer = this.handleBuffer;

    this.clone(clone);
    
    this.buildTimeline();

    this.addScroller();

    this.handleFooter(cloneFooter);

    this.update();

    this.triggerEl.block = this;
    roadmapBlocks[this.id] = this;
  }

  setActive() {
    roadmapController.setActiveBlock(this);
  }

  enter() {
    if (this.hasOverflow()) {
      window.internalScroll = this.scroller;
    } else {
      window.internalScroll = false;

      if (!mql.matches) return;
      roadmapController.freezeObserver.enable();
    }

    const { direction } = this.trigger;
    // TODO: Rework this to return blocks instead of triggers (after refactoring `getAdjacentTrigger`)
    const previous = getAdjacentTrigger(this.trigger, direction * -1);

    if (previous) {
      const previousBlock = previous.trigger.block;
      if (previousBlock.hasOverflow()) {
        const previousDestination = direction > 0 ? previousBlock.scroller.end : 0
        previous.trigger.scroll(0, previousDestination);
      }
    }
  
    this.setActive();
  }

  // TODO: Consider merging with cloneFooter logic
  clone(enabled) {
    if (!enabled) return;

    const cloneSource = this.triggerEl.parentElement.querySelector(`[data-content-source="${this.id}"]`),
          cloneDestinations = document.querySelectorAll(`[data-content-destination="${this.id}"]`);

    cloneDestinations.forEach(destination => {
      const clone = cloneSource.cloneNode(true);
      destination.appendChild(clone);
    });

    const positionEl = cloneDestinations.length < 2 ? cloneSource : cloneDestinations[1];

    this.callbacks.onRefresh.push(() => RoadmapBlock.positionClone(positionEl, cloneDestinations[0]));
  }

  static positionClone(source, destination) {
    const offset = gsap.getProperty(source, 'y');

    const top = getOffset(source) - offset;
    gsap.set(destination, { top });
  }

  static swapClone(instances, reverse = false) {
    if (instances.length < 2) return;

    instances[0].classList.toggle('is-hidden', !reverse);
    instances[1].classList.toggle('is-hidden', reverse);
  }

  updateBuffer() {
    const { pin } = this.options;
    // TODO: Clean this up - much is no longer necessary
    if (pin && this.pinBuffer) {
      // TODO: Probably remove bufferTarget?
      const bufferTarget = (typeof pin === 'boolean') ? this.triggerEl : pin;
      const spacer = bufferTarget.closest('.pin-spacer');

      this.triggerEl.bufferTarget = bufferTarget;
      if (typeof this.pinBuffer === 'function') this.pinBuffer = this.pinBuffer();
      const bufferMultiple = (typeof this.pinBuffer === 'boolean') ? 1 : parseFloat(this.pinBuffer, 10);
      bufferTarget.dataset.bufferMultiple = bufferMultiple;
      const buffer = () => `${(bufferTarget.offsetHeight || bufferTarget.innerHeight) * bufferMultiple}px`;

      gsap.set(bufferTarget, { boxSizing: 'content-box', paddingBottom: buffer });

      if (spacer) {
        gsap.set(spacer, { height: bufferTarget.offsetHeight })
      }
    }
  }

  updateHeader(color, ease) {
    color ??= this.headerColor;
    
    if (color === header.dataset.color) return
    // TODO: Figure out why this is backwards
    const direction = this.trigger.direction * -1 ?? 1;
    ease ??= direction > 0 ? 'power1.out' : 'power1.inOut(-0.5)';

    gsap.to(header, {
      '--header-color': color,
      duration: 0.3,
      ease,
      onComplete: () => header.dataset.color = color,
    });
  }

  cloneFooter() {
    const { source, destination, transientDestination } = this.footer.clone;
    const blockIndex = blocks.indexOf(this.triggerEl),
          nextBlock = blocks[blockIndex + 1],
          fixedCloneWrapper = document.createElement('div'),
          fixedClone = this.footer.trigger.cloneNode(true);

    // TODO: Fix on refresh ( review fade clone )
    destination.appendChild(source.cloneNode(true));
    const offset = getOffset(destination);
    transientDestination.appendChild(source.cloneNode(true));
    gsap.set(transientDestination, { top: `${offset}px` });

    fixedCloneWrapper.classList.add('fixed-clone-wrapper', 'fixed-clone-wrapper--footer', 'is-hidden');
    fixedCloneWrapper.style.top = `${offset}px`;

    fixedClone.classList.remove('faded-text');
    fixedCloneWrapper.appendChild(fixedClone);
    nextBlock.before(fixedCloneWrapper);

    destination.classList.add('hide-main');

    this.footer.clone.wrapper = fixedCloneWrapper;
  }

  // TODO: Rework cloning to be standardized between 3 implementations
  handleFooter(enabled) {
    if (!enabled) return;

    const id = `${this.id}-footer`;

    this.footer = {
      clone: {
        source: document.querySelector(`[data-content-source="${id}"]`),
        destination: document.querySelector(`[data-content-destination="${id}"]`),
        transientDestination: document.querySelector(`[data-transient-destination="${id}"]`),
      },
    };

    this.footer.trigger = this.footer.clone.source.parentElement;

    this.cloneFooter();

    const { trigger, clone: { destination, transientDestination, wrapper } } = this.footer;

    const options = {
      id,
      trigger,
      start: () => `top ${getOffset(destination) + (mql.matches ? this.getOverflow() : 0)}px`,
      end: () => `+=${this.triggerEl.offsetHeight - (getOffset(trigger) - (mql.matches ? this.getOverflow() : 0) - getOffset(destination))}`,
      scrub: true,
      pinnedContainer: this.triggerEl,
      onEnter: () => {
        wrapper.classList.remove('is-hidden');
        trigger.classList.add('is-hidden');
      },
      onLeave: () => {
        wrapper.classList.add('is-hidden');
        transientDestination.classList.add('is-hidden');
        destination.classList.remove('hide-main');
      },
      onLeaveBack: () => {
        wrapper.classList.add('is-hidden');
        trigger.classList.remove('is-hidden');
      },
      onEnterBack: () => {
        wrapper.classList.remove('is-hidden');
        transientDestination.classList.remove('is-hidden');
        destination.classList.add('hide-main');
      },
      onRefresh: () => {
        // TODO: Move this to update method
        RoadmapBlock.positionClone(destination, transientDestination);
        RoadmapBlock.positionClone(destination, wrapper);
      },
    };
  
    this.footer.timeline = gsap.timeline({ ease: 'none', scrollTrigger: options });
  
    addTween(this.footer.timeline, {
      target: `[data-content-source="${id}"] + .arrow`,
      props: { duration: 0.25, opacity: 0, ease: 'power1.out' },
    });
  
    // TODO: Consider calculating the values instead of estimating
    addTween(this.footer.timeline, {
      props: { duration: 0.75 },
      position: 0.3,
    });

    this.triggerEl.footerTimeline = this.footer.timeline;
  }

  buildTimeline() {
    const timelineOptions = {
      scrollTrigger: this.options
    }

    if (this.options.scrub) {
      timelineOptions.ease = 'none';
    } else {
      timelineOptions.onStart = () => window.isFrozen = true;
      timelineOptions.onComplete = () => window.isFrozen = false;
    }

    this.timeline = gsap.timeline(timelineOptions);

    for (const tween of this.tweens) addTween(this.timeline, tween, this.triggerEl);

    const hasLabel = this.tweens.some(tween => tween.type === 'label');
    if (!hasLabel) {
      addTween(this.timeline, { type: 'label', label: 'ready', position: 0 });
    }

    this.trigger = this.timeline.scrollTrigger;
    this.triggerEl.step = this.timeline;
  }

  addCallbacks() {
    for (const [event, callbacks] of Object.entries(this.callbacks)) {
      this.options[event] = self => {
        for (const callback of callbacks) callback && callback(self);
      }
    }
  }

  update() {
    this.addScroller();
  }

  // Add secondary scroll trigger to enable scroll-jacking at edges of block
  addScroller() {
    const existingScroller = ScrollTrigger.getById(`${this.id}-scroller`);

    // TODO: Clean up
    if (!this.hasOverflow() && existingScroller) {
      this.scroller.kill();
      this.scroller = null;
      this.triggerEl.classList.remove('has-overflow');
      return;
    }

    if (!this.hasOverflow() || existingScroller) return;

    this.triggerEl.classList.add('has-overflow');

    this.scroller = ScrollTrigger.create({
      id: `${this.id}-scroller`,
      trigger: this.triggerEl.firstElementChild,
      pinnedContainer: this.triggerEl,
      scroller: this.triggerEl,
      start: `top top-=${SCROLL_OFFSET}px`,
      end: `bottom bottom+=${SCROLL_OFFSET}px`,
      onLeave: () => {
        if (!mql.matches) return;
        roadmapController.freezeObserver.enable();
      },
      onLeaveBack: () => {
        if (!mql.matches) return;
        roadmapController.freezeObserver.enable();
      },
    });

    this.triggerEl.scroller = this.scroller;
  }

  getElement() {
    return this.triggerEl;
  }

  getTrigger() {
    return this.trigger;
  }

  getTimeline() {
    return this.timeline;
  }

  getHeight(pinned = false) {
    // TODO: Clean this up
    return (pinned && this.id !== '00-1' ? this.heightEl.firstElementChild : this.heightEl).offsetHeight;
  }

  getVisibleHeight() {
    return window.innerHeight - (this.id === '00-1' ? header.offsetHeight : 0);
  }

  getOverflow() {
    let difference = this.getHeight(this.options.pin) - this.getVisibleHeight();

    return difference > OVERFLOW_BUFFER ? difference : 0;
  }

  hasOverflow() {
    return this.getOverflow() > 0;
  }

  getPosition(label = 'ready') {
    return this.trigger.labelToScroll(label) || this.trigger.start;
  }

  getScrollerEnd(direction = 1) {
    return direction > 0 ? this.scroller.end : 0;
  }

  // TODO: Test
  scrollTo({
    direction = 1,
    duration = null,
    animate = true,
    onComplete,
    offset = 0,
  } = {}) {
    if (window.isScrolling) return;

    const label = (this.id === '00-1' && direction < 0) ? 'start' : 'ready';
    const y = this.getPosition(label) + offset + (direction > 0 ? this.triggerOffset : (this.getOverflow() + this.triggerOffset));
  
    scrollTo(y, { animate, duration, onComplete });
  }
}

class FadeRevealBlock extends RoadmapBlock {
  constructor(trigger, { pin = false, clone = false } = {}) {
    super(trigger, {
      clone,
      pin,
    });

    // TODO: Clean these up
    this.textEl = this.triggerEl.querySelector('[data-reveal-text]');
    this.fadeEl = this.textEl.querySelector('span:only-child, [data-extra]') ?? this.textEl;
    this.hasExtra = !!this.textEl.querySelector('[data-extra]');

    this.addFadeTrigger();

    this.handleClone(clone);
  }

  // TODO: Figure out if both this and the container one are necessary
  addFadeTrigger() {
    const { id, trigger, clone, pin } = this.options;

    const options = {
      id: `${id}-container`,
      start: 'top top',
      end: 'top top',
      pin,
      clone,
    }

    // TODO: Check second condition and clean this up
    if (this.hasExtra || !this.textEl.querySelector('[data-content-destination]')) {
      gsap.set(this.fadeEl, { backgroundPosition: '0 100%' });
      // TODO: Update to use 'initialTweens' or something similar, triggering play() & reverse() appropriately for enter and leaveBack
      options.onEnter = () => {
        gsap.to(this.fadeEl, { backgroundPosition: '0 0', duration: 1, ease: 'power2.out' });
      }
  
      options.onLeaveBack = () => {
        if (this.hasExtra) {
          gsap.to(this.fadeEl, {
            autoAlpha: 0,
            duration: 0.8,
            ease: 'power3.out',
            onComplete: () => {
              gsap.set(this.fadeEl, { backgroundPosition: '0 100%', autoAlpha: 1 });
            }
          });
        } else {
          gsap.to(this.fadeEl, { backgroundPosition: '0 100%', duration: 1, ease: 'power2.out' });
        }
      }
    }

    this.fadeTrigger = ScrollTrigger.create({
      trigger,
      ...options,
    });
  }

  getClonePosition(returnString = true) {
    const duration = window.innerHeight - (getOffset(this.textEl) - getOffset(this.clonePositionEl));
    return returnString ? `+=${duration}px` : duration;
  }

  cloneText() {
    const blockIndex = blocks.indexOf(this.triggerEl),
          nextBlock = blocks[blockIndex + 1],
          fixedCloneWrapper = document.createElement('div'),
          fixedClone = this.textEl.cloneNode(true);

    fixedCloneWrapper.classList.add('fixed-clone-wrapper', 'fixed-clone-wrapper--fade', 'is-hidden');
    RoadmapBlock.positionClone(this.clonePositionEl, fixedCloneWrapper);

    fixedClone.classList.remove('faded-text');
    fixedCloneWrapper.appendChild(fixedClone);
    nextBlock.before(fixedCloneWrapper);

    this.fixedCloneWrapper = fixedCloneWrapper;
  }

  handleClone(enabled) {
    if (!enabled) return;

    this.cloneDestinationEls = document.querySelectorAll(`[data-content-destination="${this.id}"]`);
    this.clonePositionEl = document.querySelector(`[data-content-position="${this.id}"]`);

    this.cloneText();

    const options = {
      id: `${this.id}-clone`,
      trigger: this.textEl,
      start: () => `top ${getOffset(this.clonePositionEl)}px`,
      end: () => this.getClonePosition(this.textEl),
      pinnedContainer: this.triggerEl,
      scrub: true,
      onEnter: () => {
        this.fixedCloneWrapper.classList.remove('is-hidden');
        this.textEl.classList.add('is-hidden');
      },
      onLeave: () => {
        this.fixedCloneWrapper.classList.add('is-hidden');
        RoadmapBlock.swapClone(this.cloneDestinationEls);
      },
      onLeaveBack: () => {
        this.fixedCloneWrapper.classList.add('is-hidden');
        this.textEl.classList.remove('is-hidden');
      },
      onEnterBack: () => {
        this.fixedCloneWrapper.classList.remove('is-hidden');
        RoadmapBlock.swapClone(this.cloneDestinationEls, true);
      },
      onRefresh: () => {
        // TODO: Move this to update method
        RoadmapBlock.positionClone(this.clonePositionEl, this.fixedCloneWrapper);
      }
    };

    const arrow = this.triggerEl.querySelector('.arrow');
    const getArrowDuration = () => arrow.offsetHeight / this.getClonePosition(false);

    this.cloneTimeline = gsap.timeline({ ease: 'none', scrollTrigger: options });
    addTween(this.cloneTimeline, {
      target: arrow,
      props: { duration: getArrowDuration, yPercent: 100, opacity: 0, ease: 'none' },
    });
    addTween(this.cloneTimeline, {
      props: { duration: () => 1 - getArrowDuration() },
      position: getArrowDuration,
    });
  }
}

const getLabels = () => {
  labelKeys = [];
  labelPositions = [];

  for (const trigger of Object.values(triggers)) {
    const labels = Object.keys(trigger.animation.labels);
    for (const label of labels) {
      const labelPosition = Math.max(trigger.labelToScroll(label) || trigger.start, 0);
      labelKeys.push(`${trigger.vars.id}--${label}`);
      labelPositions.push(labelPosition);
    }
  }
  // console.log(labelPositions);

  return labelPositions;
}

const initialize = () => {
  getLabels();
  document.body.classList.add('roadmap-initialized');
  roadmapController.setActiveBlock('00-1');
  roadmapController.observeHeader();

  window.initialized = true;
};

// TODO: REFACTOR HARD (and move inside RoadmapBlock class)
const getAdjacentTrigger = (trigger, direction = 1) => {
  if (!trigger) {
    const block = roadmapController.getActiveBlock();
    trigger = block.getTrigger();
  }

  if (direction === 0) return trigger;

  let current = trigger,
      adjacent = null;

  while (adjacent === null) {
    const potentialAdjacent = direction === 1 ? current.next() : current.previous();

    if (!potentialAdjacent) {
      adjacent = trigger;
      break;
    }

    if (potentialAdjacent.vars.id.match(/-/g).length <= 1) {
      adjacent = potentialAdjacent;
      break;
    }

    current = potentialAdjacent
  }

  return adjacent;
}

const getAdjacentLabelPosition = (direction = 1) => {
  if (!labelPositions.length) return false;
  const scrollPosition = Math.round(scrollContainer.scrollY ?? scrollContainer.scrollTop);
  let labelIndex = null;

  if (direction === 0) return scrollPosition;

  // TODO: Clean up
  for (const labelPosition of labelPositions) {
    const roundedPosition = Math.round(labelPosition);

    if (direction > 0) {
      if (roundedPosition > (scrollPosition + SCROLL_OFFSET)) {
        labelIndex = labelPositions.indexOf(labelPosition);
        break;
      }
    } else {
      if (roundedPosition >= (scrollPosition - SCROLL_OFFSET)) {
        labelIndex = labelPositions.indexOf(labelPosition) - 1;
        break;
      }
    }
  }

  return labelPositions[clamp(0, labelIndex, labelPositions.length - 1)];
}
const getPreviousLabelPosition = () => getAdjacentLabelPosition(-1);
const getNextLabelPosition = () => getAdjacentLabelPosition(1);

// TODO: Normalize prior to calls and remove
const normalizeBlockObject = block => {
  if (block instanceof HTMLElement) {
    // TODO: Consider replacing logic with a simple `block.step`
    const blockId = getBlockId(block);
    block = triggers[blockId]?.scrollTrigger ?? triggers[blockId] ?? block;
  }

  return (typeof block === 'string') ? triggers[block] : block;
}

const getBlockTrigger = block => {
  if (block instanceof HTMLElement) return block;

  return block.trigger;
}

// TODO: Fix this to work with trigger rather than element
const getBlockPosition = (block, label = 'ready') => {
  const trigger = block.scrollTrigger || block;
  return trigger.labelToScroll(label) || trigger.start;
}

// TODO: Polish this up for reuse
const SCROLL_DURATION_CLAMP_MIN = 200;
const SCROLL_DURATION_CLAMP_MAX = 1200;
const SCROLL_DURATION_DIVISOR = 800;
const SCROLL_DURATION_EXTENDED_DIVISOR = 4000;
const SCROLL_DURATION_MAX = 5;
const getScrollDuration = ({
  distance,
  end = null,
  start = (scrollContainer.scrollY ?? scrollContainer.scrollTop),
  min = SCROLL_DURATION_CLAMP_MIN,
  max = SCROLL_DURATION_CLAMP_MAX,
  divisor = SCROLL_DURATION_DIVISOR,
}) => {
  if (!distance && end === null) {
    console.error('Scroll duration calculation requires either a distance or an end position.');
    return 0;
  }

  distance ??= Math.abs(end - start);
  let duration = clamp(min, distance, max) / divisor;

  if (distance > max) {
    duration += (distance - max) / SCROLL_DURATION_EXTENDED_DIVISOR;
  }

  // console.log('duration', Math.min(duration, SCROLL_DURATION_MAX));

  return Math.min(duration, SCROLL_DURATION_MAX);
}

const scrollTo = (y, { animate = true, duration = null, onComplete = () => {}, animator = gsap } = {}) => {
  // Calculate scroll duration based on distance to target
  if (y === (scrollContainer.scrollY ?? scrollContainer.scrollTop)) return;
  
  // window.isScrolling = true;
  window.previousInternalScroll = false;

  // Clamp duration to prevent scrolling too fast or slow
  // duration ??= distance / 1000;
  duration ??= getScrollDuration({ end: y });
  const ease = duration > 2 ? 'sine.inOut' : 'power1.inOut';

  if (!animate) {
    scrollContainer.scrollTo({ top: y });
    window.isScrolling = false;

    return;
  }

  animateScroll(scrollContainer, {
    y,
    duration,
    ease,
    animator,
    onComplete,
  });
}

const animateScroll = (target, {
  y,
  duration,
  ease = 'power1.inOut',
  animator = gsap,
  onComplete,
} = {}) => {
  target.isScrolling = true;

  animator.to(target, {
    scrollTo: { y },
    ease,
    overwrite: false,
    duration,
    onComplete: () => {
      target.isScrolling = false;

      if (onComplete) {
        onComplete();
      }
    },
  });
}

const getInitialBlock = () => {
  if (!triggers['00-1']) return null;

  const activeBlock = roadmapController.setActiveBlock('00-1');

  // TODO: Check if necessary
  roadmapController.getActiveBlock().scrollTo({ animate: false });

  return activeBlock;
}

const getBlockId = (element, index = null) => {
  const blockId = element.dataset.block ?? element.closest('[data-block]')?.dataset.block;
  const baseId = blockId ?? element.closest('[data-section]')?.dataset.section;

  return baseId + (index !== null ? `-${index}` : '');
}

// TODO: Find a more performant way to do this
// TODO: Make this a static method for RoadmapBlock
const getOffset = target => {
  const elementBounds = target.getBoundingClientRect();
  const blockBounds = target.closest('[data-block]').getBoundingClientRect();

  return Math.abs(elementBounds.top - blockBounds.top);
}

const getDataValue = (element, key) => {
  const value = element.dataset[key];

  if (value === 'true' || value === '') return true;
  if (value === 'false') return false;

  return value;
}

const getTarget = (target, parent) => {
  return (parent && typeof target === 'string') ? parent.querySelector(target) : target;
}

// TODO: Convert to class method
const addTween = (timeline, tween, parent = null) => {
  if (tween.disabled) return;

  const { target, type, props, position, label, callback } = tween;
  let element = getTarget(target, parent);
  timeline ??= gsap;
  element ??= {};

  switch (type) {
    case 'label':
      timeline.addLabel(label, position);
      break;
    case 'callback':
      timeline.call(callback, null, position);
      break;
    case 'fromTo':
      timeline.fromTo(element, props.from, props.to, position);
      break;
    case 'from':
      timeline.from(element, props, position);
      break;
    case 'to':
    default:
      timeline.to(element, props, position);
      break;
  }
}

const animationOptions = ['pin', 'clone', 'pinBuffer', 'cloneFooter'];
const getOptions = element => {
  const options = {};

  for (const option of animationOptions) {
    if (typeof element.dataset[option] !== 'undefined') options[option] = getDataValue(element, option);
  }

  return options;
}

const getType = element => {
  return element.dataset?.animate || 'default';
}

const animateElement = element => {
  const type = getType(element);
  const options = getOptions(element);

  const step = createStep(element, type, options);
  if (step && typeof step === 'object' && step.constructor.name === 'Object') {
    triggers = { ...triggers, ...step };
  } else {
    const blockId = getBlockId(element);
    triggers[blockId] = step.scrollTrigger ?? step;
  }
}

const animationElements = document.querySelectorAll('[data-animate]');

const createStep = (element, type, options) => {
  let block;

  switch (type) {
    case 'fade-reveal':
      block = new FadeRevealBlock(element, options);
      break;
    default:
      block = new RoadmapBlock(element, options);
      break;
  }

  return block.getTimeline();
}

const hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover)')

document.addEventListener('DOMContentLoaded', () => {
  header.addEventListener('mouseenter', () => {
    if (!hoverMedia.matches) return
    header.classList.add('roadmap-hover', 'roadmap-hover--buffer')
  });

  header.addEventListener('mouseleave', () => {
    if (!hoverMedia.matches) return
    header.classList.remove('roadmap-hover')

    setTimeout(() => {
      header.classList.remove('roadmap-hover--buffer');
    }, 350);
  });
});

window.addEventListener('load', () => {
  // mm.add('(min-width: 750px)', () => {
    // TODO: Use this
  // });

  const blockIntro1 = document.querySelector('[data-block="00-1"]');
  const blockIntro2 = document.querySelector('[data-block="00-2"]');

  // TODO: Handle intro offset differently (attach offset const to block and apply to start / end / scrolls)
  const introBlock = new RoadmapBlock(blockIntro1, {
    start: 'top top',
    clone: true,
    tweens: [
      {
        type: 'label',
        label: 'start',
        position: 0,
      },
      {
        target: '.hero-content',
        type: 'fromTo',
        props: {
          from: {
            display: 'block',
            y: () => (blockIntro1.querySelector('.roadmap-block__copy')?.offsetHeight ?? 0) / 2,
          },
          to: {
            display: 'block',
            y: 0,
            duration: 0.5,
          },
        },
        position: 0,
      },
      {
        target: '.roadmap-block__copy',
        type: 'fromTo',
        props: {
          from: { autoAlpha: 0, y: 20 },
          to: { autoAlpha: 1, y: 0, duration: 0.5 },
        },
        position: 0,
      },
      {
        target: '.roadmap-block__image',
        props: { yPercent: -100, duration: 0.5, ease: 'none' },
        position: 0.5,
      },
      {
        type: 'label',
        label: 'ready',
        position: 0.5,
      },
      {
        type: 'callback',
        callback: () => {
          if (introBlock.trigger.direction < 0) return;
          // TODO: Remove magic numbers
          introBlock.updateHeader('rgb(255, 255, 255)');
        },
        position: 0.5,
      },
      {
        type: 'callback',
        callback: () => {
          if (introBlock.trigger.direction > 0) return;
          // TODO: Remove magic numbers
          introBlock.updateHeader('rgb(51, 50, 48)');
        },
        position: 0.55,
      }
    ],
    // TODO: Use constants and the like to remove these magic values
    onEnterBack: () => introBlock.updateHeader('rgb(255, 255, 255)', 'power2.out'),
    ignoreHeader: true,
  });
  // TODO: Clean up
  triggers['00-1'] = introBlock.getTrigger();

  const intro2 = new RoadmapBlock(blockIntro2, {
    pin: false,
    scrub: !mql.matches,
    tweens: [
      {
        target: document.querySelector('[data-content-destination="00-1"]'),
        type: 'fromTo',
        props: {
          from: { autoAlpha: 1 },
          to: { autoAlpha: 0, duration: 0.4, ease: 'power2.out' },
        },
        position: 0,
      },
      {
        target: '.roadmap-block__content',
        type: 'fromTo',
        props: {
          from: { autoAlpha: 0 },
          to: { autoAlpha: 1, duration: 0.4, ease: 'power2.in' },
        },
        position: 0,
      },
      { props: { duration: 1.6 }, disabled: mql.matches },
      {
        type: 'label',
        label: 'ready',
        position: mql.matches ? 0 : 0.4,
      },
    ],
    onEnter: !mql.matches ? () => {
      intro2.scrollTo();
    } : null,
  });
  // TODO: Clean up
  triggers['00-2'] = intro2.getTrigger();

  if (!mql.matches) {
    ScrollTrigger.create({
      id: '00-2-buffer',
      trigger: blockIntro2,
      pin: true,
      pinType: 'fixed',
      start: 'top top',
      end: () => `+=${intro2.getHeight() * 0.2}`,
    });
  }

  animationElements.forEach(element => animateElement(element));

  const arrows = document.querySelectorAll('[data-next-arrow]');
  arrows.forEach(arrow => {
    arrow.addEventListener('click', e => {
      e.preventDefault();

      roadmapController.handleScroll(1);
    });
  });

  const blockLinks = document.querySelectorAll('[data-block-link]');
  blockLinks.forEach(link => {
    const block = roadmapBlocks[link.dataset.blockLink];

    link.addEventListener('click', e => {
      e.preventDefault();
      block.scrollTo();
    });
  });

  initialize();

  // TOOLTIPS
  // Docs: https://atomiks.github.io/tippyjs/v6/all-props/
  // TODO: Close open tooltips when new one is opened
  const tooltips = document.querySelectorAll('[data-tooltip]');
  tooltips.forEach(tooltip => {
    tooltip.addEventListener('click', e => e.preventDefault());

    const template = document.getElementById(tooltip.dataset.tooltip);

    if (!template) return;

    tippy(tooltip, {
      content: template.innerHTML,
      allowHTML: true,
      interactive: true,
      inlinePositioning: true,
      maxWidth: 530,
      // appendTo: () => document.body,
    });
  });
});